import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {};

const slice = createSlice({
  name: 'msi',
  initialState: reHydrateStore('msi') || initialState,
  reducers: {
    setMSI: (state, { payload }) => payload,
    setMsiSelected: (state, { payload }) => ({
      ...state,
      selected: payload,
    }),
    removeSelected: (state, { payload }) => ({
      ...state,
      selected: null,
    }),
    restore: () => {},
  },
});

export const { setMSI, setMsiSelected, removeSelected, restore } = slice.actions;

export default slice.reducer;

export const selectMsi = (state) => state.msi;
